<div class="category-settings">
  <div class="protocol-settings">
    <div class="language">
      <span class="language-span" translate>Language</span>
      <div class="language-content">
        <rotec-select-v2
          placeholder="Select something"
          [secondary]="true"
          [selectedItem]="protocolSettings.protocolLanguage"
          [items]="languageItems"
          (selectedItemChange)="selectedUnitChange($event, 'language')"
        >
        </rotec-select-v2>
      </div>
    </div>
    <div class="protocol-settings-row">
      <div class="protocol-settings-key">
        <span translate>Measuring Runs</span>
      </div>

      <div class="protocol-settings-value">
        <rotec-radio-group-v2
          [options]="measuringRuns"
          [selected]="protocolSettings.measuringRuns"
          (selectedChange)="selectedUnitChange($event, 'measuringRuns')"
        >
        </rotec-radio-group-v2>
      </div>
    </div>
    <div class="units">
      <div class="item">
        <p translate>numberOfDecimalPlaces</p>
        <rotec-number-input-panel-v2
          placeholder="-"
          class="input"
          [min]="0"
          [max]="15"
          [value]="selectSettings.decimals"
          (valueChange)="selectedUnitChange($event, 'decimals')"
          onlyAllowDecimals="'true'"
        ></rotec-number-input-panel-v2>
      </div>
      <div class="item">
        <p translate>unbalUnit</p>
        <rotec-select-v2
          class="input"
          placeholder="-"
          [secondary]="true"
          [items]="unbalUnits$ | async"
          [selectedItem]="selectSettings.unbalUnit"
          (selectedItemChange)="selectedUnitChange($event, 'unbalUnit')"
        ></rotec-select-v2>
      </div>
      <div class="item">
        <p translate>Show unbalance as mass</p>
        <rotec-toggle-v2
          [small]="true"
          [active]="selectSettings.isUnbalanceAsMass"
          (activeChange)="toggleUnbalanceAsMass($event)"
        ></rotec-toggle-v2>
      </div>
      <div class="item">
        <p translate>massUnit</p>
        <rotec-select-v2
          class="input"
          placeholder="-"
          [secondary]="true"
          [items]="massUnits$ | async"
          [selectedItem]="selectSettings.weightUnit"
          (selectedItemChange)="selectedUnitChange($event, 'weightUnit')"
        ></rotec-select-v2>
      </div>
      <div class="item">
        <p translate>lengthUnit</p>
        <rotec-select-v2
          class="input"
          placeholder="-"
          [secondary]="true"
          [items]="lengthUnits$ | async"
          [selectedItem]="selectSettings.lengthUnit"
          (selectedItemChange)="selectedUnitChange($event, 'lengthUnit')"
        ></rotec-select-v2>
      </div>
      <div class="item">
        <p translate>nominalSpeedUnit</p>
        <rotec-select-v2
          class="input"
          placeholder="-"
          [secondary]="true"
          [items]="nominalSpeedUnits$ | async"
          [selectedItem]="selectSettings.rotationUnit"
          (selectedItemChange)="selectedUnitChange($event, 'rotationUnit')"
        ></rotec-select-v2>
      </div>
    </div>
  </div>
</div>
